export default __webpack_public_path__ + "static/media/single-project-page-04-img06.ceec75e5.jpg";